import { render, staticRenderFns } from "./gzzoc-anemia.vue?vue&type=template&id=5e8fc66e&scoped=true&lang=pug&"
import script from "./gzzoc-anemia.vue?vue&type=script&lang=js&"
export * from "./gzzoc-anemia.vue?vue&type=script&lang=js&"
import style0 from "./gzzoc-anemia.vue?vue&type=style&index=0&id=5e8fc66e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e8fc66e",
  null
  
)

export default component.exports